module.exports = __webpack_public_path__ + "img/deleting.acb06f00.svg";